import { t } from 'i18next';
import { getMagazineTextObject } from 'PDF/helpers/pdfMapping';
import { getProductDescriptionData } from 'PDF/helpers/productDescriptionMapping';
import { StageStatusEnum } from 'PDF/types/timeline';

import { IBusinessToolForm } from 'components/BusinessToolForm/utils/form';

export const getProductAndServicesProps = (businessPlanChapters: IBusinessToolForm, isExamplePage: boolean) => {
  const { competitionAdvantage, productDevelopmentPlans } = businessPlanChapters.GLOBAL;

  const {
    description: { qualityStandards, productsOrServicesAndTheirPurpose },
    advantages: { productValue },
    randd: { timelines, readinessLevel, conductedActivities, resources, weaknesses },
    deliveryAndSupport: { logistics, postPurchase, anyWarranty },
  } = businessPlanChapters.PRODUCTS_AND_SERVICES;

  const developmentTimeline = timelines
    .map((timeline) => ({
      startDate: timeline.startDate,
      endDate: timeline.endDate,
      stage: timeline.stage,
      status: timeline.status?.value as StageStatusEnum,
    }))
    .filter(({ startDate, endDate, stage }) => startDate && endDate && stage);

  const magazineItems = [
    [
      getMagazineTextObject(
        isExamplePage ? 'Products/Services Overview. ' : t('pdfPages.mappings.businessOperations.productsServicesOverview'),
        productsOrServicesAndTheirPurpose,
      ),
    ],
    [getMagazineTextObject(isExamplePage ? 'Quality Standards. ' : t('pdfPages.mappings.businessOperations.qualityStandards'), qualityStandards)],
    [
      getMagazineTextObject(isExamplePage ? 'Product Uniqueness. ' : t('pdfPages.mappings.businessOperations.productUniqueness'), competitionAdvantage),
      getMagazineTextObject(isExamplePage ? 'Customer Value. ' : t('pdfPages.mappings.businessOperations.customerValue'), productValue),
    ],
    [
      getMagazineTextObject(
        isExamplePage ? 'Production and Implementation Readiness. ' : t('pdfPages.mappings.marketingAndSales.productionAndImplementationReadiness'),
        readinessLevel,
      ),
      getMagazineTextObject(isExamplePage ? 'R&D Progress. ' : t('pdfPages.mappings.marketingAndSales.rAndDProgress'), conductedActivities),
    ],
    [
      getMagazineTextObject(isExamplePage ? 'Required Resources. ' : t('pdfPages.mappings.marketingAndSales.requiredResources'), resources),
      getMagazineTextObject(isExamplePage ? 'Product Deficiencies and Solutions.  ' : t('pdfPages.mappings.marketingAndSales.productDeficienciesAndSolutions'), weaknesses),
      getMagazineTextObject(isExamplePage ? 'New Product Plans.  ' : t('pdfPages.mappings.marketingAndSales.newProductPlans'), productDevelopmentPlans),
    ],
    [
      getMagazineTextObject(isExamplePage ? 'Logistics and Delivery. ' : t('pdfPages.mappings.marketingAndSales.logisticsAndDelivery'), logistics),
      getMagazineTextObject(isExamplePage ? 'Support and Maintenance Services. ' : t('pdfPages.mappings.marketingAndSales.supportAndMaintenanceServices'), postPurchase),
      getMagazineTextObject(isExamplePage ? 'Warranty and Return Programs.  ' : t('pdfPages.mappings.marketingAndSales.warrantyAndReturnPrograms'), anyWarranty),
    ],
  ];

  return {
    magazineItems,
    data: {
      ...getProductDescriptionData(businessPlanChapters),
      developmentTimeline,
    },
  };
};
